import modalHtml from './modal.component.html';
import './modal.component.scss';

class ModalController {
    constructor($scope, $compile, $timeout, CartService) {
        'ngInject';

        this.$scope = $scope;
        this.$compile = $compile;
        this.$timeout = $timeout;
        this.CartService = CartService;
        this.uniqueId = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5);
        this.debounce = null;
    }

    $onInit() {
        this.$scope.$watch(
            () => this.isOpen,
            (newVal, oldVal) => {
                if (newVal) {
                    this.$timeout(() => {
                        this.$scope.clickOutside = () => {
                            if (!this.isOpen) return;
                            if (!this.params.allowClose) return;
                            
                            this.close();
                            this.$scope.$apply();
                        };
                    }, 500)
                } else {
                    if (this.debounce) {
                        this.$timeout.cancel(this.debounce);
                        this.debounce = null;
                    }
                    this.$scope.clickOutside = null;
                }
            }
        );
    }

    $postLink() {
        this.$timeout(() => {
            this.bindContent();
        });
    }

    bindContent() {
        const contentContainer = document.getElementById(this.uniqueId);
        const $contentContainer = angular.element(contentContainer);

        $contentContainer.empty().append(this.params.content);

        this.$compile($contentContainer.contents())(this.$scope);
    }

    close(data = null) {
        this.isOpen = false;
        this.params.close(data);
    }

    hasSimilarProductsFor(productId) {
        const pId = parseInt(productId, 10);
        if (!pId) {
            return false;
        }

        const list = (this.CartService && this.CartService.similarProducts) ? this.CartService.similarProducts : [];

        return list.some(p => {
            if (!p || !Array.isArray(p.similar_for_product_ids)) return false;
            return p.similar_for_product_ids.map(x => parseInt(x, 10)).includes(pId);
        });
    }
}

let modalComponent = {
    bindings: {
        params: '<',
        isOpen: '<'
    },
    template: modalHtml,
    controller: ModalController
}

export default modalComponent;